"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonIcon = exports.buttonFullWidth = exports.buttonIsLoading = exports.buttonTertiary = exports.buttonSecondary = exports.buttonBase = void 0;

var _stylitas = require("@creditas/stylitas");

const rotation = (0, _stylitas.keyframes)`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
`;

const buttonDisabled = ({
  theme
}) => (0, _stylitas.css)`
    cursor: not-allowed;
    background-color: ${theme.bColorneutral04};
    color: ${theme.bColorneutral06};

    svg {
      fill: ${theme.bColorneutral06};
    }
  `;

const buttonBase = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.button(theme)}
  background-color: ${theme.bColorsecondary05};
  border: none;
  border-radius: 8px;
  color: ${theme.bColorneutral01};
  cursor: pointer;
  display: inline-block;
  line-height: 32px;
  min-width: 270px;
  overflow: hidden;
  padding: 8px 16px;
  position: relative;
  transition: color 0.3s ease;
  z-index: 1;

  svg {
    fill: ${theme.bColorneutral01};
  }

  &:hover {
    background-color: ${theme.bColorsecondary06};
  }

  &:disabled {
    ${buttonDisabled({
  theme
})};
  }

  &::after {
    content: '';
    border: solid 2px ${theme.bColorneutral01};
    border-left-color: transparent;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    margin-top: -8px;
    margin-left: -8px;
    opacity: 0;
    transition: opacity 0.2s 0.1s ease;
  }
`;

exports.buttonBase = buttonBase;

const buttonSecondary = ({
  theme,
  variant
}) => variant === 'secondary' && (0, _stylitas.css)`
    background-color: transparent;
    border: 1px solid ${theme.bColorsecondary05};
    color: ${theme.bColorsecondary05};
    line-height: 30px;

    svg {
      fill: ${theme.bColorsecondary05};
    }

    &:focus,
    &:hover {
      color: ${theme.bColorsecondary05};
      background-color: ${theme.bColorsecondary01};
      border-color: ${theme.bColorsecondary06};
    }

    &:disabled {
      color: ${theme.bColorneutral04};
      border-color: ${theme.bColorneutral05};
      background-color: transparent;

      svg {
        fill: ${theme.bColorneutral04};
      }
    }

    &::after {
      border-color: ${theme.bColorsecondary05};
      border-left-color: transparent;
    }
  `;

exports.buttonSecondary = buttonSecondary;

const buttonTertiary = ({
  theme,
  variant
}) => variant === 'tertiary' && (0, _stylitas.css)`
    color: ${theme.bColorsecondary05};
    background-color: transparent;
    border: none;

    svg {
      fill: ${theme.bColorsecondary05};
    }

    &:focus,
    &:hover {
      color: ${theme.bColorsecondary06};
      background-color: transparent;

      svg {
        fill: ${theme.bColorsecondary06};
      }
    }

    &:disabled {
      color: ${theme.bColorneutral04};
      background-color: transparent;

      svg {
        fill: ${theme.bColorneutral04};
      }
    }

    &::after {
      border-color: ${theme.bColorsecondary05};
      border-left-color: transparent;
    }
  `;

exports.buttonTertiary = buttonTertiary;
const iconLoading = (0, _stylitas.css)`
  svg {
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  ::after {
    left: 90%;
  }
`;
const textLoading = (0, _stylitas.css)`
  span {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
`;

const buttonIsLoading = ({
  isLoading,
  hasIcon
}) => isLoading && (0, _stylitas.css)`
    &::after {
      animation: ${rotation} 0.5s infinite linear;
      opacity: 1;
    }

    ${hasIcon && iconLoading}
    ${!hasIcon && textLoading}
  `;

exports.buttonIsLoading = buttonIsLoading;

const buttonFullWidth = ({
  fullWidth
}) => fullWidth && (0, _stylitas.css)`
    min-width: 100%;
    width: 100%;
  `;

exports.buttonFullWidth = buttonFullWidth;

const buttonIcon = ({
  hasIcon
}) => hasIcon && (0, _stylitas.css)`
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      transform: scale(2.2, 2.2);
    }
  `;

exports.buttonIcon = buttonIcon;